export enum FormFieldType {
  ShortText = 'shortText',
  Radio = 'radio',
  Mobile = 'mobile',
  Nric = 'nric',
  Dropdown = 'dropdown',
}
